<template>
  <div class="technical-information">
    <transition
      name="accordion"
      @before-enter="beforeEnter"
      @enter="enter"
      @before-leave="beforeLeave"
      @leave="leave">
      <div v-show="isTechnicalInformationBlockActive(productId) || showTechnicalnformation" class="technical-information__content">
        <slot></slot>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    productId: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters('ui', ['showTechnicalnformation', 'isTechnicalInformationBlockActive']),
    svgClass() {
      return this.isOpen ? 'svg--90-negative' : 'svg--90'
    }
  },
  methods: {
    beforeEnter: function(el) {
      el.style.maxHeight = '0'
    },
    enter: function(el) {
      el.style.maxHeight = el.scrollHeight + 100 + 'px'
    },
    beforeLeave: function(el) {
      el.style.maxHeight = el.scrollHeight + 100 + 'px'
    },
    leave: function(el) {
      el.style.maxHeight = '0'
    }
  }
}
</script>

<style lang="scss">
.technical-information {
  border: 1px solid color(border-gray);
  border-width: 0 1px;
}

.technical-information__content {
  display: flex;
  background-color: color(background-blue-6);
  border-bottom: 1px solid color(border-gray);
  padding: 0 measure(half);
  overflow: hidden;
}

.technical-information__content .property-container:not(:last-child) {
  margin-right: measure(half);
}

.accordion-enter-active,
.accordion-leave-active {
  translate: max-height 180ms;
}

.accordion-enter,
.accordion-leave-to {
  max-height: 0;
}
</style>
